<h1>Our Team</h1>
<div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
  <queblo-person-card fxFlex="" *ngFor="let person of people" [person]="person"></queblo-person-card>
</div>
